import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import ListRole from "./ListRole";

const UpdateRoleModal = ({
  title,
  isOpen,
  toggle,
  onSubmit,
  values,
  setting,
  onChange,
  onChangePermission,
  isChecked,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" backdrop={true}>
      <Form onSubmit={(e) => onSubmit(e)}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="name" className="text-muted">
              <IntlMessages id="name" />
              <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="text"
              name="name"
              id="name"
              value={values.name}
              onChange={onChange}
            />
          </FormGroup>
          <FormGroup>
            <ListRole
              settings={values.settings}
              onChangePermission={onChangePermission}
              isChecked={isChecked}
              roleType={values.roleType}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">
            <IntlMessages id="general.btn-update" />
          </Button>{" "}
          <Button color="secondary" type="button" onClick={toggle}>
            <IntlMessages id="general.btn-cancel" />
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default React.memo(UpdateRoleModal);
